module.exports = __webpack_public_path__ + "img/product10.99116127.png";